<template>
    <v-card :loading="loading">
        <v-card-title>
            Settings
        </v-card-title>
        <v-card-text>
            <v-form ref="settingsForm" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-select v-model="databaseType" dense :items="databaseTypeItems" label="Database Type" outlined
                            placeholder="Please select a database type" :rules="databaseTypeRules"
                            @change="resetValue()">
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-select v-if="databaseType == 'legacy'" v-model="year" dense :items="yearItems" label="Year"
                            outlined placeholder="Please select a year" :rules="yearRules">
                        </v-select>
                        <v-select v-else v-model="residenceTerm" dense :items="residenceTerms" label="Residence Term"
                            outlined placeholder="Please select a residence term" :rules="residenceTermRules">
                        </v-select>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text" :color="successColor" :disabled="!valid" :loading="loading"
                @click="generateStatistics()">Generate
                Statistics</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'statistics-settings',
    props: {
        residenceTerms: {
            required: true
        },
        yearItems: {
            required: true
        }
    },
    data() {
        return {
            databaseType: 'modern',
            databaseTypeItems: [{
                    text: 'Modern',
                    value: 'modern'
                },
                {
                    text: 'Legacy',
                    value: 'legacy'
                }
            ],
            databaseTypeRules: [
                v => !!v || 'Database type is required'
            ],
            loading: false,
            residenceTerm: '',
            residenceTermRules: [
                v => !!v || 'Residence term is required'
            ],
            year: '',
            yearRules: [
                v => !!v || 'Year is required'
            ],
            valid: true
        }
    },
    methods: {
        generateStatistics() {
            if (this.$refs.settingsForm.validate()) {
                this.loading = true;
                this.$emit('generateStatistics', this.databaseType, this.databaseType == 'legacy' ? this.year : this.residenceTerm);
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                });
            }
        },
        resetValue() {
            this.residenceTerm = '';
            this.year = '';
        }
    },
    computed: {
        successColor() {
            return '#1dc9b7';
        },
    }
}
</script>